import * as React from 'react';
import { Layout, Button } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import { locationsRestCrudThunksForSupplier } from '../../thunks/locations_thunks';
import { getEntityById, nullSafeGet } from '../../utils/DataAccessUtils';
import {
	getProtectedImageUriForSupplier,
	getProtectedImageUriFromString,
} from '../../utils/FileAccessUtils';
import { ROLE_TYPES } from '../../utils/DataConstants';
import Carousel, { Modal as Lightbox, ModalGateway } from 'react-images';
import { generateBackLink } from '../../utils/HistoryUtils';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { isSupplierAllowedToAccess, PERMISSION_NAMES } from '../../utils/AuthUtils';
import { Link } from 'react-router-dom';
import NextPreviousButton from '../next_previous_button/NextPreviousButton';
import { LOCATIONS_CRUD_ACTION_CREATORS } from '../../actions/locations_actions';
import { updatePaginationEntities } from '../../thunks/thunks_wrapper';

require('./SupplierLocationsDetailPage.less');
const queryString = require('qs');
const { Content } = Layout;

class SupplierLocationsDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentIndex: 0,
			fromTargetCollectionName: null,
		};
	}

	handleViewChange = (idx) => {
		this.setState({ currentIndex: idx });
	};

	openLightbox = (currentIndex = 0) => {
		this.setState({ lightboxIsOpen: true, currentIndex });
	};

	closeLightbox = () => {
		this.setState({ lightboxIsOpen: false });
	};

	componentDidMount() {
		const { getLocation, updateNavbar, match, location, wolocation } = this.props;
		const locationId = match.params.id;

		let searchString = location.search;
		if (searchString[0] === '?') {
			searchString = searchString.slice(1);
		}
		updateNavbar(
			'Back to Locations',
			generateBackLink('/supplier/locations/overview/all', location)
		);
		const queryParams = queryString.parse(searchString);
		if (queryParams.targetCollectionName) {
			this.setState({
				fromTargetCollectionName: queryParams.targetCollectionName,
			});
		}
		if (queryParams.backlinkParams) {
			this.setState({
				loading: false,
				backLinkTo: `/supplier/locations/overview/all?${queryParams.backlinkParams}`,
			});
		} else {
			this.setState({
				loading: false,
				backLinkTo: `/supplier/locations/overview/all`,
			});
		}
		if (!nullSafeGet('id', wolocation)) {
			getLocation(locationId);
		}
	}
	componentWillUnmount(): void {
		this.props.clearNavbar();
	}

	handleTabChange = (key) => {
		const { history, match } = this.props;
		const locationId = match.params.id;
		history.push(`/supplier/locations/detail/${locationId}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	render() {
		const {
			wolocation,
			match,
			history,
			locations,
			location,
			updatePagination,
			cloneTargetCollection,
			companyConfig,
			currentUser,
		} = this.props;
		const locationId = match.params.id;
		const tabs = [
			{
				key: 'details',
				name: 'Overview',
			},
			{
				key: 'walkthroughs',
				name: 'Walkthroughs',
			},
			{
				key: 'audit',
				name: 'Audit Logs',
			},
		];
		if (
			isSupplierAllowedToAccess(
				PERMISSION_NAMES.ACCESS_LOCATION_DOCUMENTS,
				companyConfig,
				nullSafeGet('roles', currentUser)
			)
		) {
			tabs.push({
				key: 'documents',
				name: 'Documents',
			});
		}
		let photoUris = [];
		let lightboxPhotoUris = [];
		if (wolocation.images) {
			photoUris = wolocation.images.slice(0, 4).map((locImg) => {
				const [imgFileId, imgFileName] = locImg.split('/');
				return getProtectedImageUriForSupplier(imgFileId, imgFileName, 1200, 800);
			});
			lightboxPhotoUris = wolocation.images.map((photoString) => ({
				src: getProtectedImageUriFromString(ROLE_TYPES.SUPPLIER)(photoString, 2400, 1600),
			}));
		}
		return (
			<div>
				<Route
					path="/supplier/locations/detail/:id"
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `/supplier/locations/detail/${locationId}/details`,
							}}
						/>
					)}
				/>
				<Content className="supplierLocationsDetailPage">
					{/*<ScrollToTopOnMount/>*/}
					{/*<BackTop/>*/}
					<ModalGateway>
						{this.state.lightboxIsOpen ? (
							<Lightbox onClose={this.closeLightbox}>
								<Carousel
									trackProps={{
										onViewChange: this.handleViewChange,
									}}
									views={lightboxPhotoUris}
									currentIndex={this.state.currentIndex}
								/>
							</Lightbox>
						) : null}
					</ModalGateway>

					<div className="imageLayout">
						{photoUris.map((photoUri, idx) => (
							<div
								key={idx}
								className={`imageTile imageTile${idx}`}
								style={{ backgroundImage: `url(${photoUri})` }}
							/>
						))}
						<div
							className={`imageLayout__gradientOverlay ${
								wolocation.isActive ? '' : 'imageLayout__gradientOverlay--darker'
							}`}
						>
							{!wolocation.isActive ? <div className="locationInactiveLabel">Inactive</div> : null}
							<div className="supplierLocationsDetailPage__overtitle">
								{nullSafeGet('locationType.name', wolocation)} {nullSafeGet('storeId', wolocation)}
							</div>
							<h4 className="supplierLocationsDetailPage__title">{wolocation.name}</h4>
							<SubnavTabs
								tabs={tabs}
								onChange={this.handleTabChange}
								isActive={this.checkTabActive}
							/>
							<AccessPermissionChecker name={PERMISSION_NAMES.MODIFY_LOCATIONS}>
								<div style={{ position: 'absolute', top: 40, right: 40 }}>
									<Link to={`/supplier/locations/edit/${locationId}`} style={{ marginRight: 16 }}>
										<Button ghost={true}>Edit</Button>
									</Link>
								</div>
							</AccessPermissionChecker>
							<div
								style={{ position: 'absolute', bottom: 40, right: 40 }}
								className="flex flex-row items-baseline"
							>
								{lightboxPhotoUris.length > 0 ? (
									<Button
										style={{ color: 'white', marginRight: 16 }}
										type="ghost"
										onClick={() => this.openLightbox()}
									>
										View Photos
									</Button>
								) : null}
								<NextPreviousButton
									key={this.state.fromTargetCollectionName}
									location={location}
									history={history}
									activeId={nullSafeGet('id', wolocation)}
									getEnitityUrl={(id) => `/supplier/locations/detail/${id}/details`}
									stateSlice={locations}
									targetCollectionName={this.state.fromTargetCollectionName}
									updatePagination={updatePagination}
									cloneTargetCollection={cloneTargetCollection}
									entityName="location"
								/>
							</div>
						</div>
					</div>
					{this.props.childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	locationsFetching: state.locations.fetching,
	wolocation: getEntityById(ownProps.match.params.id, state.locations),
	match: ownProps.match,
	history: ownProps.history,
	locations: state.locations,
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({
	getLocation: (id) => dispatch(locationsRestCrudThunksForSupplier.readOne(id)),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
	cloneTargetCollection: (from, to) =>
		dispatch(LOCATIONS_CRUD_ACTION_CREATORS.cloneTargetCollection(from, to)),
	updatePagination: (pagination, targetCollectionName) =>
		dispatch(
			updatePaginationEntities('supplier', 'locations', locationsRestCrudThunksForSupplier)(
				false,
				undefined,
				targetCollectionName,
				pagination,
				true
			)
		),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierLocationsDetailPage)
);
